<template>
  <div class="flex flex-col min-h-screen bg-inherit">
    <slot />
  </div>
</template>
